import { useAuthorizationResolver } from './useAuthorizationResolver.js';
/**
 * Evaluates a single {@link AuthorizationPredicate} against the current session context
 * (user, license, feature flags) and returns the resulting boolean.
 *
 * Use for a **single** imperative check. For declarative JSX gating, prefer `<Guard>`; for
 * evaluating many predicates in the same render (loops, `.filter()`, `.map()`), use
 * {@link useAuthorizationResolver} to avoid violating the rules of hooks.
 *
 * @example
 * ```tsx
 * const canViewAnalytics = useIsAuthorized(({user}) => user.canViewAnalyticsData);
 * ```
 */ export var useIsAuthorized = function useIsAuthorized(canRender) {
    return useAuthorizationResolver()(canRender);
};

//# sourceMappingURL=useIsAuthorized.js.map